<template>
  <div>
    <loader :full-screen="true" :preview-loader="true" :show-loader="campaignLoading" class="loading"/>
    <div class="card-header">
      <span class="title">
        MODELO DO CARTAZ
        <i
            :data-content="infoData"
            class="fa fa-info-circle info-icon"
            data-html="true"
            data-placement="bottom"
            data-toggle="popover"
            data-trigger="hover">
        </i>
        <button v-show="false" class="float-right" @click.prevent="fetchSelectorPack">
          Recarregar
        </button>
      </span>
    </div>
    <loader :show-loader="loading"></loader>
    <div v-if="!loading" class="panel-body">
      <div
          :data-intro="'Clique para escolher a ' + campaignDescription + ' do produto.'"
          class="form-group"
          data-step="2">
        <label for="selectCampaign">
          {{ campaignDescription }}
        </label>

        <select
            id="selectCampaign"
            v-model='campaign_id'
            :disabled="!canSelectCampaign"
            class="form-control select2">
          <option v-for="campaign in campaigns" :value="campaign.id">
            {{ campaign.name }}
          </option>
        </select>
      </div>

      <div class="form-group" data-intro="Clique para escolher o tamanho do cartaz." data-step="3">
        <label for="selectFormat">
          {{ paperDescription }}
        </label>
        <select
            id="selectFormat"
            v-model='paper_format_id'
            :disabled="!canSelectFormat"
            class="form-control select2">
          <option v-for="format in formats" :value="format.id">
            {{ format.formatted_name }}
          </option>
        </select>
      </div>

      <div class="form-group" data-intro="Clique para escolher o modelo do cartaz." data-step="4">
        <label for="selectTemplate">
          {{ templateDescription }}
        </label>
        <select
            id="selectTemplate"
            v-model="template_id"
            :disabled="!canSelectTemplate"
            class="form-control" @input="emitShouldCreateEvent">
          <option v-for="template in templates" :value="template.id">
            {{ template.name }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="selectTheme">
          {{ themeDescription }}
        </label>
        <select
            id="selectTheme"
            v-model="theme_id"
            :disabled="!canSelectTheme"
            class="form-control select2"
            @input="emitShouldCreateEvent">
          <option v-for="theme in themes" :value="theme.id">
            {{ theme.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from './Loader';
import SelectorService from './services/selector_service';

export default {
  components: {Loader},
  props: [
    'templateId',
    'idTheme',
    'defaultContent',
    'campaignDescription',
    'posterId',
    'subDomain',
    'createFromRegister',
    'posterPermissions',
    'action',
  ],
  mounted() {
    this.isFirstLoadOnEdit = true;
    this.isCreate = true;
    this.fetchSelectorPack();
  },
  watch: {
    campaign_id(campaign_id) {
      let formats = this.dataSource.listFormats;
      let templates = this.dataSource.listTemplates;

      if (formats && templates) {
        this.formats = formats.filter((format) => {
          let hasTemplate = templates.filter((template) => {
            return (template.paper_format_id === format.id
                && template.campaign_id === campaign_id);
          });

          if (hasTemplate.length)
            return format;
        });

        this.$store.commit('selector/SET_FILTERED_PAPER_FORMATS', this.formats);
      }
      const campaign = this.campaigns.find((item) => item.id === campaign_id)

      this.$root.$emit('magazine-change-dynamic', true);
      this.$store.commit('selector/SET_CAMPAIGN', campaign);
      this.$store.commit('selector/SET_CAMPAIGN_ID', campaign_id);
    },

    paper_format_id(paper_format_id) {
      if (paper_format_id) {
        if (this.dataSource.listTemplates) {
          this.templates = this.dataSource.listTemplates.filter((template) => {
            if (template.paper_format_id === paper_format_id
                && template.campaign_id === this.campaign_id)
              return template;
          });

          this.templates.sort(function (a, b) {
            if (b.name < a.name)
              return 1;

            if (b.name > a.name)
              return -1;

            return 0;
          });

          this.$store.commit('selector/SET_FILTERED_TEMPLATES', this.templates);
        }
      }
    },
    template_id(template_id) {
        this.theme_id = undefined;

      if (template_id) {
        this.campaignLoading = true;

        if (!this.isFirstLoadOnEdit) {
          this.theme_id = undefined;
        }
        this.isCreate = false;

        if (this.templates) {
          const template = this.templates.find((template) => {
            return template.id === template_id;
          });

          this.fetchTemplateContentById(template);

          this.themes = this.dataSource.listThemes.filter((theme) => {
            const isFormatBought = ((theme.paper_format_id === template.paper_format_id) && theme.bought);
            if (theme.id === template.theme_id || isFormatBought) {
              return theme
            }
          });

          this.themes.sort(function (a, b) {
            if (b.name < a.name)
              return 1;

            if (b.name > a.name)
              return -1;

            return 0;
          });

          this.$store.commit('selector/SET_FILTERED_THEMES', this.themes);
        }

        if (this.isMagazine && this.$store.getters['poster/getSelectedProduct'].code !== ' ') {
          this.$root.$emit('updateMagazineProduct');
        }
      }
    },
    theme_id(theme_id) {
      if (theme_id) {
        this.setThemeById(theme_id);
      }
    },
    idTheme() {
      this.themeId = this.idTheme;
    },
    templateId(templateId) {
      if (templateId) {
        this.loadTemplateFromProp();
      }
    },
    campaigns() {
      if (this.createFromRegister) {
        this.populateSelectsFromRegister();
      }
    },
  },
  data() {
    return {
      loading: true,
      state: this.$store.state.selector,
      themeId: undefined,
      theme_id: undefined,
      template_id: undefined,
      campaign_id: undefined,
      paper_format_id: undefined,
      isCreate: true,
      isfirstLoadOnEdit: true,
      campaignLoading: false,

      campaigns: [],
      formats: [],
      templates: [],
      themes: [],

      dataSource: {
        listFormats: [],
        listTemplates: [],
        listThemes: [],
      },
    };
  },
  computed: {
    canOnlyEditFormat() {
      return this.posterPermissions.format
          && !this.posterPermissions.campaign
          && !this.posterPermissions.template
          && !this.posterPermissions.theme;
    },
    canSelectCampaign() {
      if (this.action == 'create')
        return true;
      return this.posterPermissions.campaign || this.isMagazine;
    },
    canSelectFormat() {
      if (this.action == 'create')
        return true;
      return this.posterPermissions.format || this.isMagazine;
    },
    canSelectTemplate() {
      if (this.action == 'create')
        return true;
      return this.posterPermissions.template || this.isMagazine;
    },
    canSelectTheme() {
      if (this.action == 'create')
        return true;
      return this.posterPermissions.theme || this.isMagazine;
    },
    infoData() {
      return '<div>' +
          '<p><strong>Dinâmica Comercial</strong> é a forma que o produto está sendo ofertado ou precificado para venda.</p>' +
          '<p><strong>Tamanho</strong> define o formato do cartaz que vai ser fixado no ponto de venda.</p>' +
          '<p><strong>Layout Coordenada</strong> é o padrão visual do texto e do valor do cartaz.</p>' +
          '<p><strong>Campanha</strong> é o gatilho visual que vai atrair seu cliente para o produto. </p>' +
          '<div>'
    },
    paperDescription() {
      return (this.isMagazine) ? 'Tamanho do cartaz' : 'Tamanho';
    },
    templateDescription() {
      return (this.isMagazine) ? 'Tipo de campanha' : 'Layout Coordenada';
    },
    themeDescription() {
      return 'Campanha';
    },
    isMagazine() {
      return this.subDomain === 'magazineluiza';
    },
    has_more_than_one_theme() {
      if (!this.isMagazine)
        return true;
      if (this.themes) {
        return (this.themes.length > 1);
      }
      return false;
    },
  },
  methods: {
    populateSelectsFromRegister() {
      this.$nextTick().then(() => {
        this.campaign_id = _.get(this.campaigns, '[0].id');
      }).then(() => {
        this.paper_format_id = _.get(this.formats, '[0].id');
      }).then(() => {
        this.template_id = _.get(this.templates, '[0].id');
        this.emitShouldCreateEvent();
      }).then(() => this.showTour());
    },
    showTour() {
      var showTour = $('#show-tour').val();
      var userId = $('#user-id').val();
      var postersTour = localStorage.getItem('postersCreateTour-' + userId);
      if (false) {
        localStorage.setItem('postersCreateTour-' + userId, '1');
        tour.setOptions(
            {
              'exitOnOverlayClick': false,
              'exitOnEsc': false,
              'showStepNumbers': false,
              'showProgress': true,
              'tooltipPosition': 'auto',
              'doneLabel': 'Avançar',
              'prevLabel': 'Anterior',
              'nextLabel': 'Próximo',
              'skipLabel': 'Pular',
              'scrollToElement': false,
            }).goToStepNumber(2).oncomplete(function () {
          window.location.href = '/online/posters';
        }).start();
      }
    },
    emitShouldCreateEvent(value) {
      this.$root.$emit('posterShouldCreate');
      this.$emit('on-template-selected');
    },

    setCampaignDefaultMagazine() {
      if (this.isMagazine) {
        let campaign = this.campaigns.find(item => item.name === 'PARCELADO COM JUROS');
        if (campaign && campaign.id) {
          this.campaign_id = campaign.id;
        }
      }
    },

    fetchSelectorPack() {
      SelectorService.fetchSelectorPack(this.posterId).then((response) => {
        this.campaigns = response.campaigns;
        this.setCampaignDefaultMagazine();
        this.dataSource.listFormats = response.paper_formats;
        this.dataSource.listTemplates = response.templates;
        this.dataSource.listThemes = response.themes;

        if (this.templateId) {
          this.loadTemplateFromProp();
        }
        this.$emit('ready');
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$root.throwFlashMessage('danger', error.message);
      });
    },
    loadTemplateFromProp() {
      let template = this.dataSource.listTemplates.find((template) => template.id === this.templateId);
      if (template) {
        this.campaign_id = template.campaign_id;
        this.paper_format_id = template.paper_format_id;
        this.template_id = this.templateId;
        this.$emit('on-template-selected');
      }
    },
    fetchTemplateContentById(template) {
      SelectorService.fetchTemplateContentById(template.id).then((response) => {
        template.content = (this.isFirstLoadOnEdit && this.defaultContent)
            ? this.defaultContent
            : response.content;
        template.fonts_size = response.fonts_size;
        template.default_font = response.default_font;
        template.images_template = response.images_template;
        template.format_name = response.format_name;
        this.$store.commit('selector/SET_TEMPLATE', template);
        this.$store.commit('poster/SET_INITIAL_CONTENT', template.content);
        this.$store.commit('poster/SET_CONTENT', template.content);
        if (this.themeId && this.isFirstLoadOnEdit) {
          this.setThemeById(this.themeId);
          this.themeId = undefined;
        } else {
          let currentTheme = (this.themes.length === 1) ? this.themes[0].id : template.theme_id;
          this.setThemeById(currentTheme);
        }
        this.isFirstLoadOnEdit = false;
      }).then(() => this.$root.$emit('handleCustomQRCode', !!this.custom_qr_code))
          .catch((error) => {
            this.$root.throwFlashMessage('danger', error.message);
          });
    },
    setThemeById(theme_id) {
      this.theme_id = theme_id;
      let theme = this.themes.find((theme) => theme.id === theme_id);
      if (theme) {
        this.$store.commit('selector/SET_THEME', theme);
      }
      this.campaignLoading = false;
    },
  },
};
</script>

<style scoped>
.widget {
  margin-bottom: 0;
}

.widget-head {
  border: 1px solid #3540512b;
  background: #D7E3E5;
  color: black;
  padding: 0 20px;
}

.panel-body {
  background-color: #fff;
  border: 1px solid #3540511f;
}

.loading {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Selector.vue